import React from "react";
import styled from "styled-components";

const img_sample = require("../../../assets/img/colorNamesTest.png");

interface IProps {
  colors: string[];
  scale: number;
}

const Container = styled.div<{backgroundImage: string, scale: number}>`
  position: relative;
  width: 1240px;
  height: 1844px;
  background-image: url(${props => props.backgroundImage});
  transform: scale(${props => props.scale});
  transform-origin: left top;
`
const Text = styled.div<{x: number, y: number, color: string}>`
  position: absolute;
  left: ${props => props.x}px;
  top: ${props => props.y}px;
  color: ${props => props.color};
  font-size: 60px;
  font-weight: bold;
`

const ColorNamesPresetView = ({
  colors,
  scale
}: IProps) => {
  return (
    <Container
      scale={scale}
      backgroundImage={img_sample}>
      {colors?.map((color, index) => {
        if (index < 13) {
          return <Text x={190} y={116 + 124 * index} color={`#${color}`}>{index + 1}</Text>
        } else if (index < 19) {
          return <Text x={550} y={142 + 177 * (index - 13)} color={`#${color}`}>{index + 1}</Text>
        } else if (index < 25) {
          return <Text x={980} y={142 + 177 * (index - 19)} color={`#${color}`}>{index + 1}</Text>
        } else if (index < 27) {
          return <Text x={470} y={1268 + 324 * (index - 25)} color={`#${color}`}>{index + 1}</Text>
        } else if (index < 29) {
          return <Text x={740} y={1268 + 324 * (index - 27)} color={`#${color}`}>{index + 1}</Text>
        } else if (index < 31) {
          return <Text x={1030} y={1268 + 324 * (index - 29)} color={`#${color}`}>{index + 1}</Text>
        }
      })}
    </Container>
  );
}

export default ColorNamesPresetView;